var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 19.668,
    viewBox: "0 0 20 19.668",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m11.029.285 8 4.8A2 2 0 0 1 20 6.8v10.868a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6.8a2 2 0 0 1 .971-1.715l8-4.8a2 2 0 0 1 2.058 0zM18 7.536l-8 5.333-8-5.333v10.132h16V7.536zM10 2 3.316 6.01 10 10.466l6.684-4.456L10 2z",
    fill: "#606064"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailOpen);
export default __webpack_public_path__ + "static/media/mail-open.12593b314a0664235a5de89dec7d6b40.svg";
export { ForwardRef as ReactComponent };